import { ISAMLLoginManager } from "../interfaces/saml";

export interface ISAMLConfig {
    loginPageURL: string;
    logoutPageURL: string;
}

export class SAMLLoginManager implements ISAMLLoginManager {
    private config: ISAMLConfig;

    constructor(config: ISAMLConfig) {
        this.config = config;
    }

    public login(): void {
        // Redirect user to the SAML server login page
        window.location.replace(this.config.loginPageURL);
    }

    public logout(): void {
        window.location.replace(this.config.logoutPageURL);
    }

    public isCurrentPageSAMLLogin(): boolean {
        if (window.location.pathname && window.location.pathname.indexOf("SAMLLogin") >= 0) {
            return true;
        } else {
            return false;
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/common/saml.ts